import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core'
import { PostsService } from '../../../services/posts-service'
import { Customer, Post } from '../../../types'

@Component({
  selector: 'redeliver-post-modal',
  styles: [`
  `],
  template: `
    <modal (outsideClick)="closeModal()">
      <h4>Redeliver Post</h4>
      <hr class="brand-hr">
      <div [ngSwitch]="customer.postDeliveryMethod" class="biggish-text small-bottom-buffer">
        <ng-template [ngSwitchCase]="'alternate_email'">
          Emailing post to {{ customer.emailForPosts }}...
        </ng-template>
        <ng-template [ngSwitchCase]="'wordpress'">
          Delivering post to your WordPress account...
        </ng-template>
        <ng-template [ngSwitchCase]="'hubspot'">
          Delivering post to your HubSpot account...
        </ng-template>
      </div>

      <div *ngIf="successful" class="text-green bold biggish-text">
        Successful
      </div>
      <ng-template [ngIf]="!successful && !!error">
        <div class="text-brick-red bold biggish-text">Failed</div>
        <div class="error">{{ error }}</div>
      </ng-template>

      <div class="top-buffer">
        <button (click)="closeModal()" class="btn btn-primary float-right">Done</button>
      </div>
      <div style="clear: both;"></div>
    </modal>
  `
})
export class RedeliverPostModal implements OnInit {
  @Input() customer: Customer;
  @Input() post: Post;
  @Output() onClose = new EventEmitter();
  successful: boolean;
  error: string;

  ngOnInit(): void {
    new PostsService().redeliver(this.post.customerId, this.post.id).then(() => {
      this.successful = true
    }).catch((err) => {
      this.error = err.text
    })
  }

  closeModal() {
    this.onClose.emit('done')
  }
}
